import {COI} from '../../model/shared/user/user';
import {BaseResponse} from '../../response/internal/baseresponse';
import {LicenseBlur, ResponseLicenseBlur} from '../../view-model/agent/licenseblur';
import {Api} from '../config/api';
import {AgentService} from './agent.service';
import {RequestService} from './request.service';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

@Injectable()
export class LicenseBlurService {

  constructor(
    public requestService: RequestService,
    public agentService: AgentService
  ) {

  }


  public blur(license: LicenseBlur): Observable<ResponseLicenseBlur> {
    return this.requestService.post(Api.Agent.LicenseBlur, this.agentService._options, license, ResponseLicenseBlur);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/licenseblur.service.ts